import React, { useContext, useEffect, useState } from 'react';
import { FormGroup, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FilterCollapsableWrapper } from '../../../../components/Filters/FiltersWrappers/FilterCollapsableWrapper/FilterCollapsableWrapper';
import SelectField from '../../../../components/Filters/Components/selectorAndAutocomplete/components/selectField/selectField';
import ObrasAPI from '../../../../services/APIObras';
import { FilterContext } from '../../../../context/FilterProvider';
import { Mode } from '../../../../types/FiltersTypes';
import { Option } from '../../../../types/Option';
import FILTER_TYPES from '../../../../components/Filters/filterTypes';

const SustainabilityCertificationSelector = () => {
  const { i18n, t } = useTranslation();
  const filterContext = useContext(FilterContext);
  const [certificateOptions, setCertificateOptions] = useState<Option[]>([]);
  const [levelOptions, setLevelOptions] = useState<Option[]>([]);

  const selectedType = filterContext.filters[FILTER_TYPES.sustainableCertificationType]?.[0];
  const selectedLevel = filterContext.filters[FILTER_TYPES.sustainableCertificationLevel]?.[0];

  useEffect(() => {
    ObrasAPI.getInstance().getSustainabilityCertificateOptions()
      .then(setCertificateOptions)
      .catch(() => setCertificateOptions([]));
  }, [i18n.language]);

  useEffect(() => {
    if (!selectedType?.code) {
      setLevelOptions([]);
      return;
    }

    ObrasAPI.getInstance().getSustainabilityCertificateLevelOptions(String(selectedType.code))
      .then(setLevelOptions)
      .catch(() => setLevelOptions([]));
  }, [i18n.language, selectedType?.code]);

  const selectCertificate = (option: Option) => {
    filterContext.handleReplaceFilters({
      [FILTER_TYPES.sustainableCertificationType]: [option],
      [FILTER_TYPES.sustainableCertificationLevel]: [],
    });
  };

  return (
    <FilterCollapsableWrapper
      filterType={FILTER_TYPES.sustainableCertification}
      noBottomDivider
      tagsDisabled
    >
      <FormGroup>
        <Typography sx={{ px: 1.5, pt: 1, color: '#696969' }}>
          {t('filters.sustainableCertificationType')}
        </Typography>
        <SelectField
          options={certificateOptions}
          selectedValue={selectedType as Option}
          placeholder="filters.filtersPlaceHolder.select"
          handleSelect={selectCertificate}
        />
        <Typography sx={{ px: 1.5, pt: 1, color: '#696969' }}>
          {t('filters.sustainableCertificationLevel')}
        </Typography>
        <SelectField
          options={levelOptions}
          selectedValue={selectedLevel as Option}
          placeholder="filters.filtersPlaceHolder.select"
          disabled={!selectedType?.code}
          handleSelect={(option) => filterContext.handleChange(
            FILTER_TYPES.sustainableCertificationLevel,
            option,
            Mode.REPLACE,
          )}
        />
      </FormGroup>
    </FilterCollapsableWrapper>
  );
};

export default SustainabilityCertificationSelector;
